import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

export default function LegalShell({ title, lastUpdated, children, testId }) {
  return (
    <div className="min-h-screen bg-slate-50">
      <div className="max-w-3xl mx-auto px-6 py-12" data-testid={testId}>
        <Link to="/" className="inline-flex items-center gap-1.5 text-sm text-slate-500 hover:text-slate-900 mb-6">
          <ArrowLeft size={14} /> Retour à l'accueil
        </Link>
        <h1 className="font-display text-4xl font-bold text-slate-900">{title}</h1>
        {lastUpdated && (
          <p className="text-sm text-slate-500 mt-2">Dernière mise à jour : {lastUpdated}</p>
        )}
        <div className="prose prose-slate max-w-none mt-8 text-slate-700 [&_h2]:font-display [&_h2]:font-semibold [&_h2]:text-slate-900 [&_h2]:text-xl [&_h2]:mt-8 [&_h2]:mb-3 [&_h3]:font-semibold [&_h3]:text-slate-800 [&_h3]:mt-5 [&_p]:leading-relaxed [&_ul]:pl-6 [&_ul]:list-disc [&_ul]:my-3 [&_ol]:pl-6 [&_ol]:list-decimal [&_li]:my-1">
          {children}
        </div>
      </div>
    </div>
  );
}
